import { CCol, CRow } from "@coreui/react";
import React, { useEffect, useState } from "react";
import CommonList from "../crud/CommonList";
import { apiCall } from "src/_apiConfig/apiCall";
// import usersData from "../users/UsersData";
const LotBidderDetails = () => {
  const [usersData, setuserData] = useState();
  const [loading, setloading] = useState(false);

  useEffect(() => {
    getLotBidderdetails();
  }, []);
  const fields = [
    { key: "Login Id" },
    { key: "Company Name", _style: { width: "10%" } },
    { key: "Lot number. Quantity(In standard)", _style: { width: "20%" } },
    { key: "Purchase Rate per S.B.", _style: { width: "20%" } },
    { key: "Purchase Price (In Rs.)", _style: { width: "20%" } },
    { key: "Agreement", _style: { width: "10%" } },
    { key: "Agreement st", _style: { width: "10%" } },
    { key: "Action", _style: { width: "10%" } },
    {
      key: "show_details",
      label: "",
      _style: { width: "1%" },
      sorter: false,
      filter: false,
    },
  ];
  const getLotBidderdetails = async () => {
    setloading(true);
    const header = new Headers();
    // header.append("", "");
    const response = await apiCall(`User/getCGMFOfficers`, "GET", header, null);

    if (response.status === 200) {
      const jsonobj = await response.json();
      setuserData(jsonobj);
    }
    setloading(false);
  };
  return (
    <CRow>
      <CCol xl={12}>
        <CommonList
          items={usersData}
          fields={fields}
          listName="Lot Bidder details"
          loading={loading}
          tabBtn="Edit"
        />
      </CCol>
    </CRow>
  );
};
export default LotBidderDetails;
